/**
 * Bottom inset reserved for the floating OS dock so windowed content does not
 * sit underneath it. Maximized windows use the full desktop and hide the dock.
 */
export const OS_DOCK_SAFE_AREA_BOTTOM_REM = 7;

/** CSS length for `bottom` on the desktop window bounds layer. */
export const OS_DOCK_SAFE_AREA_BOTTOM_CSS = `${OS_DOCK_SAFE_AREA_BOTTOM_REM}rem`;

/**
 * Resolves the dock inset in pixels from the document root font size.
 *
 * @param rootFontSizePx - Root `font-size` in px (default 16)
 * @returns Pixel height to subtract from desktop `clientHeight` for layout math
 */
export function getOsDockSafeAreaBottomPx(
  rootFontSizePx = 16,
  options?: { reserveDockSpace?: boolean },
): number {
  if (options?.reserveDockSpace === false) {
    return 0;
  }
  return OS_DOCK_SAFE_AREA_BOTTOM_REM * rootFontSizePx;
}

/** Tailwind padding-bottom class so pinned footers stay above the OS dock overlay. */
export function osDockSafeAreaPaddingClass(): string {
  return `pb-[${OS_DOCK_SAFE_AREA_BOTTOM_REM}rem]`;
}
